import { useState } from 'react';
import DrawerFlow, { type DrawerFlowStep } from 'src/UI/drawer-flow/DrawerFlow';
import { initialSmartCreateData, type SmartCreateData } from './types';
import DetailsFormStep from './steps/DetailsFormStep';
import FrnStep from './steps/FrnStep';
import ProcessingStep from './steps/ProcessingStep';
import ContractReviewStep from './steps/ContractReviewStep';
import DoneStep from './steps/DoneStep';

type SmartCreateDrawerProps = {
  opened: boolean;
  close: () => void;
};

const steps: DrawerFlowStep<SmartCreateData>[] = [
  {
    id: 'details',
    title: 'Company details',
    screens: [{ component: DetailsFormStep, allowVerticalOverflow: true }],
  },
  {
    id: 'frn',
    title: 'FCA number',
    screens: [{ component: FrnStep, allowVerticalOverflow: true }],
  },
  {
    id: 'processing',
    title: 'Setting up',
    screens: [{ component: ProcessingStep }],
  },
  {
    id: 'contract',
    title: 'Review contract',
    screens: [{ component: ContractReviewStep, allowVerticalOverflow: true }],
  },
  {
    id: 'done',
    title: 'Done',
    screens: [{ component: DoneStep }],
  },
];

export default function SmartCreateDrawer({ opened, close }: SmartCreateDrawerProps) {
  const [data, setData] = useState<SmartCreateData>(initialSmartCreateData);

  return (
    <DrawerFlow
      opened={opened}
      close={close}
      title="Smart create"
      steps={steps}
      initialData={initialSmartCreateData}
      data={data}
      setData={setData}
      drawerProps={{ closeOnEscape: false }}
    />
  );
}
